export const getHeap = (): IHeap | undefined => {
  const maybeHeap = (window || global)?.heap;
  return window.feature_switch_heap ? maybeHeap : undefined;
};
